import { useManagementGetCompanies } from '@apps-common/apis/management/company/get-companies'
import { useManagementGetContacts } from '@apps-common/apis/management/contact/get-contacts'
import { useManagementGetProducts } from '@apps-common/apis/management/product/get-products'
import { IUnitManagementSelectOption } from '@apps-common/types/form'
import { ICompanyListModel } from '@apps-common/types/management/company'
import { IContactListModel } from '@apps-common/types/management/contact'
import { IProductListModel } from '@apps-common/types/management/product'

interface IManagementUnitSelectItem {
  defaultValue: string
  options: IUnitManagementSelectOption[]
  refetch: any
}

export interface IManagementOrderSelectItems {
  isLoading: boolean
  companies: ICompanyListModel[]
  contacts: IContactListModel[]
  products: IProductListModel[]
}

export const useManagementOrderSelectItems = (): IManagementOrderSelectItems => {
  const {
    data: companies,
    isLoading: companiesLoading,
    isError: companiesError,
    refetch: companiesRefetch
  } = useManagementGetCompanies({
    config: {
      staleTime: 60000
    },
    name: ''
  })

  const {
    data: contacts,
    isLoading: contactsIsLoading,
    isError: contactsIsError,
    refetch: contactsRefetch
  } = useManagementGetContacts({
    config: {
      staleTime: 60000
    },
    search: ''
  })

  const {
    data: products,
    isLoading: productsLoading,
    isError: productsError,
    refetch: productsRefetch
  } = useManagementGetProducts({
    config: {
      staleTime: 60000
    },
    name: ''
  })

  const isLoading = companiesLoading || companiesError || contactsIsLoading || contactsIsError || productsLoading || productsError

  return isLoading
    ? {
        isLoading,
        companies: [],
        contacts: [],
        products: []
      }
    : {
        isLoading,
        companies: companies || [],
        contacts: contacts || [],
        products: products || []
      }
}
